/* ============================================================
   TITAN-3 的骨架常數（第三台機體：strongman 體型）
   ============================================================

   三台的比例軸是**同一條線上的三個點**，這樣玩家換機體才有感覺：

                  全高    寬高比   腿佔比   關節    站姿寬
     CHASSIS-0    4.90    0.92     53%     逆關節   ±0.48
     LANCER-2     4.18    1.06     47%     正關節   ±0.62
     TITAN-3      3.86    1.32     43%     正關節   ±0.76   ← 最矮、最寬

   LANCER-2 是健體的 **V 錐**（寬肩細腰）。TITAN-3 不是把 V 錐再拉大 ——
   那只會讀成「比較大的 LANCER」。大力士（strongman）的體型是**桶**：
   腰不收、腹厚、整個軀幹前後也厚，四肢短到手臂垂不下來（被背闊撐開）。

   剪影上的判準：**LANCER-2 的腰看得穿，TITAN-3 的腰看不穿。**
   60px 的戰場鏡頭下能讀到的就只有這個。 */

/** 站立基準姿態。動畫層（`mech-anim.ts`）會覆蓋大部分，這是偏移的原點。 */
export var TPOSE = {
  legL: { hip: 0.30, knee: -0.74 },   // 左＝支撐腿
  legR: { hip: 0.42, knee: -0.88 },   // 右＝前踏腿
  hipYaw: 0.30,               // 髖線轉 17°：三台裡最開的馬步
  pelvisTilt: 0.09,
  torsoRoll: -0.05,
  /* 只前傾 7°（LANCER-2 是 15°）。前傾是近戰「壓過去」的語言，
     重砲機體要站得住 —— 它的動作是**架砲**不是撲上去。 */
  torsoPitch: 0.12,
  headYaw: -0.12,
  headPitch: 0.06,
  /* `armRoll` 給到 −0.34（CHASSIS-0 是 −0.22）：手臂被背闊肌撐開。
     這是大塊頭最好認的一個特徵 —— 手臂**垂不下來**，
     上臂與軀幹之間永遠有一道楔形的縫。 */
  armPitch: -0.06, armYaw: -0.30, armRoll: -0.34,
  aimConverge: 0.08,
  forePitch: -1.24,           // 砲管平舉、略微上揚（榴彈是拋射的）
  pylonRoll: -0.22, pylonYaw: 0.10,
  /* 步幅最短。短腿配大步幅會變成劈腿，配上這個體重更會讀成飄
     （LANCER-2 的註解記過同一條）。 */
  stride: 0.20, strideK: 0.42
};

/** `bodyY` 是站立時髖在世界的高度（未套用 PROP.scale）。 */
export var TSTANCE = { bodyY: 1.30, ankle: 0.22, stance: 0.76 };

/** 骨架長度。`knee: -1` 取 IK 的另一支解（膝往後折的人型腿）。
    l1 + l2 + foot = 1.56（三台裡最短），站立髖高只有 1.30 → 膝永遠彎著，
    而且比 LANCER-2 更深：這台站著就是**紮馬**的姿勢。

    ⚠️ `titan-legs.ts` 的 `knee`／`ankle` 靜態位置必須等於 `-l1`／`-l2`，
    不然靜態站姿與動畫層算出來的 IK 會差一截（腿在開場那一幀會跳）。 */
export var TIK = { l1: 0.68, l2: 0.66, foot: 0.22, knee: -1 };
